// messagesApi.js
import  apiClient  from '../../../../services/apiClient';

export const messagesApi = {
    // Отримати список повідомлень
    getMessagesList: (email, dateFrom, dateTo, status) => {
        const link = `messages_list?email=${email}&dateFrom=${dateFrom}&dateTo=${dateTo}&status=${status}`;
        return apiClient.get(link);
    },

    // Додати відповідь на повідомлення
    addMessageAnswer: (id, name, email, status, answerText) => {
        const link = `messages_add_answer?id=${id}&name=${encodeURIComponent(name)}&email=${email}&status=${status}`;
        const body = { answerText };
        return apiClient.put(link, body);
    }
};